import React from "react";

/**
 * Friendly animated robot mascot for the floating Master Chat bubble.
 * Pure SVG + CSS keyframes (see index.css: .jr-bot-*). The left eye blinks,
 * the right eye winks occasionally, and the antenna light pulses.
 */
export const RobotAvatar = ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true" className="jr-bot">
        {/* antenna */}
        <line x1="32" y1="7" x2="32" y2="15" stroke="var(--jr-brand)" strokeWidth="2.5" strokeLinecap="round"/>
        <circle cx="32" cy="6" r="3.4" fill="var(--jr-brand)" className="jr-bot-antenna"/>
        {/* ears */}
        <rect x="8" y="30" width="6" height="12" rx="3" fill="var(--jr-brand)" opacity="0.85"/>
        <rect x="50" y="30" width="6" height="12" rx="3" fill="var(--jr-brand)" opacity="0.85"/>
        {/* head */}
        <rect x="13" y="15" width="38" height="38" rx="12" fill="var(--jr-surface-2)" stroke="var(--jr-brand)" strokeWidth="2.5"/>
        {/* face screen */}
        <rect x="18" y="22" width="28" height="24" rx="8" fill="var(--jr-bg)"/>
        {/* eyes */}
        <rect x="24" y="28" width="5.5" height="9" rx="2.75" fill="var(--jr-info)" className="jr-bot-eye-l"/>
        <rect x="34.5" y="28" width="5.5" height="9" rx="2.75" fill="var(--jr-info)" className="jr-bot-eye-r"/>
        {/* smile */}
        <path d="M26 41 Q32 45 38 41" stroke="var(--jr-info)" strokeWidth="2" strokeLinecap="round" fill="none"/>
        {/* cheeks */}
        <circle cx="21.5" cy="39" r="2" fill="var(--jr-brand)" opacity="0.5"/>
        <circle cx="42.5" cy="39" r="2" fill="var(--jr-brand)" opacity="0.5"/>
    </svg>
);

export default RobotAvatar;
